import React from 'react';

const LocaleContext = React.createContext({
  setLocale: () => {},
  locale: {}
});

class LocaleProvider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      locale: {
        value: 'en-US',
        label: 'English (United States)'
      }
    };
  }

  setLocale = (event) => {
    this.setState({
      locale: event.value
    });
  };

  render() {
    const { locale } = this.state;
    const { children } = this.props;
    return (
      <LocaleContext.Provider
        // eslint-disable-next-line react/jsx-no-constructed-context-values
        value={{
          locale,
          setLocale: this.setLocale
        }}
      >
        {children}
      </LocaleContext.Provider>
    );
  }
}

export default LocaleProvider;
export const LocaleConsumer = LocaleContext.Consumer;